module.exports = __webpack_public_path__ + "img/jogo-de-talheres.759ac862.png";